import { ProductScreen } from '../features/catalog/ProductScreen'

export function ProductPage() {
  return <ProductScreen />
}
